import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonSize, ButtonVariant, IconName } from '@as/cotopaxi';
import { isNullOrUndefined, setTooltip } from '@as-react/common-utils';
import { CheckIcon, MinusIcon } from '@yonderland/andes-icons';
import { Box, Divider, Icon, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { GLOSSARY_KEY } from '../../constants/GeneralConstants';
import { GRID_AREAS } from './ProductGroupPdpComparison';
export const ProductGroupPdpComparisonFeatureItem = ({ name, value, productIndex, featureIndex, isGlossaryLoaded, shouldInitGlossaryTooltip, }) => {
    const [isTooltipApplied, setIsTooltipApplied] = useState(false);
    const tooltipId = `feature-item-${productIndex}-${featureIndex}`;
    const getGlossaryItem = (title, isLoaded) => { var _a; return isLoaded ? (_a = window[GLOSSARY_KEY]) === null || _a === void 0 ? void 0 : _a.find((glossary) => glossary.triggers.includes(title)) : null; };
    const glossaryItem = useMemo(() => getGlossaryItem(name, isGlossaryLoaded), [isGlossaryLoaded, shouldInitGlossaryTooltip]);
    useEffect(() => {
        if (!!glossaryItem && !isTooltipApplied) {
            setTooltip({
                element: `#${tooltipId}`,
                content: glossaryItem.description,
                title: glossaryItem.title,
                showCloseButton: false,
            });
            setIsTooltipApplied(true);
        }
    }, [glossaryItem]);
    const featureGridArea = `${GRID_AREAS.PRODUCT}-${productIndex}-${GRID_AREAS.FEATURE}-${featureIndex}`;
    let renderValue = (_jsx(TextAlpha, { variant: "bodyS", lineClamp: 3, children: value }));
    if (isNullOrUndefined(value)) {
        renderValue = null;
    }
    else if (typeof value === 'boolean') {
        renderValue = value ? (_jsx(Icon, { source: CheckIcon, size: "sm", color: "success" })) : (_jsx(Icon, { source: MinusIcon, size: "sm", color: "neutral" }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { gridArea: `${featureGridArea}-${GRID_AREAS.FEATURE_TITLE}` }, children: _jsxs(Box, { paddingInline: { base: '2', md: '4' }, children: [featureIndex > 0 && (_jsx(Box, { paddingBlock: { base: '3', lg: '4' }, children: _jsx(Divider, {}) })), _jsxs(Stack, { align: "center", children: [_jsx(TextAlpha, { color: "subtle", variant: "bodyS", as: "span", children: name }), glossaryItem && (_jsx(Button, { id: tooltipId, text: name, variant: ButtonVariant.TRANSPARENT_ALT, size: ButtonSize.XSMALL, icon: {
                                        name: IconName.INFORMATION_OUTLINE,
                                        color: 'N500',
                                    } }))] })] }) }), _jsx("div", { style: { gridArea: `${featureGridArea}-${GRID_AREAS.FEATURE_VALUE}` }, children: _jsx(Box, { paddingBlockStart: { base: '1' }, paddingInline: { base: '2', md: '4' }, children: renderValue }) })] }));
};
